import Big from 'big.js'
import WaitingPeriodInterestOptions from '~/data/wpi_options.json';
export default {
    calculate(lineSize, waitingPeriod, waitingPeriodInterestRate) {
        const waitingPeriodDecimal = new Big(waitingPeriod).div(360);
        const waitingPeriodInterestRateDecimal = new Big(waitingPeriodInterestRate).div(100);
        return new Big(lineSize).times(waitingPeriodDecimal).times(waitingPeriodInterestRateDecimal).toFixed(2);
    },
    submissionHasWaitingPeriodInterest(waitingPeriodInterestPolicy) {
        if (typeof waitingPeriodInterestPolicy === "undefined") {
            return false;
        }
        let noWpi = WaitingPeriodInterestOptions.find(function (option) {
            return option.value == "wpi_none";
        });
        return (waitingPeriodInterestPolicy !== noWpi.value);
    },
    wpiIsIncludedInEstimatedPremium(waitingPeriodInterestPolicy) {
        if (typeof waitingPeriodInterestPolicy === "undefined") {
            return false;
        }
        let wpiIncludedInPremium = WaitingPeriodInterestOptions.find(function (option) {
            return option.value == "wpi_included";
        });
        return (waitingPeriodInterestPolicy === wpiIncludedInPremium.value);
    },
    methods:{
        onlyForCurrency($event) {
            let elementValue = $event.target.value;
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && (keyCode !== 45) && (keyCode !== 46 || elementValue.indexOf('.') != -1)) {
                $event.preventDefault();
            }
            if (elementValue !== null && elementValue.indexOf(".") > -1 && (elementValue.split('.')[1].length > 1)) {
                $event.preventDefault();
            }
        },
    }
};
